import { KeyboardArrowLeft } from "@mui/icons-material";
import { Box, ImageList, ImageListItem, Typography } from "@mui/material";

const itemData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export function MPhotographSection({
  handleClose,
}: {
  handleClose: () => void;
}) {
  return (
    <Box display="flex" flexDirection="column">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        bgcolor="#af9b65"
        py={2}
      >
        <Box
          display="flex"
          alignItems="center"
          onClick={handleClose}
          color="white"
          position="absolute"
          left={10}
          top="50%"
          sx={{ transform: "translateY(-50%)" }}
        >
          <KeyboardArrowLeft />
          <Typography fontWeight="bold">戻る</Typography>
        </Box>
        <Typography color="white" variant="h6" fontWeight="bold">
          フォトギャラリー
        </Typography>
      </Box>
      <ImageList cols={3} rowHeight={126}>
        {itemData.map((item) => (
          <ImageListItem key={item.toString()}>
            <img
              srcSet={`/images/store-detail/img${item}.jpg?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
              src={`/images/store-detail/img${item}.jpg?w=164&h=164&fit=crop&auto=format`}
              alt={item.toString()}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}
